import React from 'react';
import './title.scss';

const Title = (props) => <div className="title">
  <span className="title__sm subtitle">{props.subTitle}</span>
  <h2 dangerouslySetInnerHTML={{__html: props.title}}></h2>
</div>;

export default Title;
